import { isRtl } from 'utils/uiHelpers'

export const formatMonth = isRtl ? 'MMMM' : 'MMM'
